import antiNausea from './initial/flow';
import antiNauseaFollowup from './followup/flow';

const AntiNauseaFlows = {
  antiNausea,
  antiNauseaFollowup
};

export default AntiNauseaFlows;
